const FETCH = 'OVID/FETCH_LOGISTIC_ORDERS'
const FETCH_SUCCESS = 'OVID/FETCH_LOGISTIC_ORDERS_SUCCESS'
const FETCH_ERROR = 'OVID/FETCH_LOGISTIC_ORDERS_ERROR'

export const constants = {
  FETCH,
  FETCH_SUCCESS,
  FETCH_ERROR,
}
